<template>
    <footer-info-chip v-if="lastConnectionDate" class="whitespace-nowrap" :class="connectionClass">
        {{ lastConnectionText }}
    </footer-info-chip>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { useI18n } from "vue-i18n";
    import { useConnectionState } from "@/services/connection-state.service";
    import FooterInfoChip from "@/components/footer/FooterInfoChip.vue";

    const { t } = useI18n({ useScope: "global" });

    const { lastConnectionDate, hasRecentLastConnection, minutesSinceLastConnection } = useConnectionState();

    const connectionClass = computed(() => (hasRecentLastConnection.value ? "bg-success" : "bg-danger"));

    const lastConnectionText = computed(() => {
        if (hasRecentLastConnection.value) {
            return t("deviceIsOnline", { minutes: minutesSinceLastConnection.value });
        } else {
            return t("deviceIsOfflineSince", { minutes: minutesSinceLastConnection.value });
        }
    });
</script>
